export default "__VITE_ASSET__Co02v_p0__";